import {
	Footer,
	ProgressBar,
	Questions,
	RiskqDescription,
	RiskqLegend,
	RiskqText,
	RiskqTextBottom,
	RiskqTitle
} from 'components';
import { useRiskq } from 'hooks/useRiskq';

export function Appropriateness() {
	const ctx = useRiskq('appropriateness');
	return (
		<ProgressBar page={ctx.page}>
			<RiskqTitle {...ctx} />
			<RiskqText {...ctx} />
			<RiskqDescription {...ctx} />
			<RiskqLegend {...ctx} />
			<Questions {...ctx} />
			<RiskqTextBottom />
			<Footer {...ctx} />
		</ProgressBar>
	);
}
